import { UnreadMessagesProvider } from '@contexts/unreadMessagesContext'
import { ConversationsProvider } from '@contexts/conversationsContext'
import { NotificationsProvider } from '@contexts/notificationsContext'
import { GlobalPopoverProvider } from '@contexts/globalPopoverContext'
import { FeedbackToastProvider } from '@contexts/feedbackToastContext'
import { FollowingFeedProvider } from '@contexts/followingFeedContext'
import { NearbyFilterProvider } from '@contexts/nearbyFilterContext'
import { TravelModeProvider } from '@contexts/travelModeContext'
import { NearbyFeedProvider } from '@contexts/nearbyFeedContext'
import { ForYouFeedProvider } from '@contexts/forYouFeedContext'
import { PostStatsProvider } from '@contexts/postStatsContext'
import { SnackBarProvider } from '@contexts/snackBarContext'
import { MapDataProvider } from '@contexts/mapDataContext'
import { DrawerProvider } from '@contexts/drawerContext'
import { ModalProvider } from '@contexts/modalContext'
import { CableProvider } from '@contexts/cableContext'

// The providers here need the access to the useLocation and useNavigate hooks among other react router APIs
const ProvidersWithRouteAccess = ({ children }) => {
  return (
    <MapDataProvider>
      <CableProvider>
        <UnreadMessagesProvider>
          <ConversationsProvider>
            <SnackBarProvider>
              <FeedbackToastProvider>
                <DrawerProvider>
                  <NearbyFilterProvider>
                    <GlobalPopoverProvider>
                      <PostStatsProvider>
                        <ModalProvider>
                          <NotificationsProvider>
                            <ForYouFeedProvider>
                              <FollowingFeedProvider>
                                <NearbyFeedProvider>
                                  <TravelModeProvider>
                                    {children}
                                  </TravelModeProvider>
                                </NearbyFeedProvider>
                              </FollowingFeedProvider>
                            </ForYouFeedProvider>
                          </NotificationsProvider>
                        </ModalProvider>
                      </PostStatsProvider>
                    </GlobalPopoverProvider>
                  </NearbyFilterProvider>
                </DrawerProvider>
              </FeedbackToastProvider>
            </SnackBarProvider>
          </ConversationsProvider>
        </UnreadMessagesProvider>
      </CableProvider>
    </MapDataProvider>
  )
}

export default ProvidersWithRouteAccess
